var createStylesheet = function(chunkId, fullhref, resolve, reject) {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = function(event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	document.head.appendChild(linkTag);
	return linkTag;
};
var findStylesheet = function(href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = function(chunkId) {
	return new Promise(function(resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	2143: 0
};

__webpack_require__.f.miniCss = function(chunkId, promises) {
	var cssChunks = {"197":1,"311":1,"490":1,"547":1,"757":1,"844":1,"855":1,"869":1,"926":1,"1156":1,"1192":1,"1218":1,"1278":1,"1336":1,"1473":1,"1491":1,"1682":1,"1690":1,"1744":1,"1889":1,"1962":1,"1990":1,"2055":1,"2362":1,"2406":1,"2518":1,"2558":1,"2634":1,"2661":1,"2704":1,"2823":1,"2968":1,"3115":1,"3132":1,"3183":1,"3336":1,"3396":1,"3468":1,"3571":1,"3887":1,"3897":1,"4142":1,"4254":1,"4452":1,"4531":1,"4590":1,"4714":1,"4765":1,"4875":1,"4893":1,"5014":1,"5089":1,"5186":1,"5461":1,"5526":1,"5539":1,"5576":1,"5598":1,"5716":1,"5780":1,"5796":1,"5840":1,"6005":1,"6035":1,"6053":1,"6131":1,"6356":1,"6393":1,"6442":1,"6468":1,"6493":1,"6502":1,"6622":1,"6749":1,"6805":1,"6815":1,"6851":1,"6948":1,"6950":1,"7036":1,"7097":1,"7172":1,"7261":1,"7328":1,"7427":1,"7499":1,"7756":1,"7831":1,"8034":1,"8245":1,"8317":1,"8518":1,"8522":1,"8567":1,"8780":1,"8792":1,"8878":1,"8891":1,"9096":1,"9244":1,"9344":1,"9358":1,"9580":1,"9784":1,"9803":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(function() {
			installedCssChunks[chunkId] = 0;
		}, function(e) {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr